import { render, staticRenderFns } from "./UsersNew.vue?vue&type=template&id=6397fb96&lang=pug&"
import script from "./UsersNew.vue?vue&type=script&lang=ts&"
export * from "./UsersNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports